import React from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import { IconButton, Tooltip } from '@material-ui/core';
import { get } from 'lodash';
import { productJsonProps } from '../../Constants/Products';

const downloadTxt = 'Download';

// Product download button component.
const ProductDownloadButton = ({ product }) => {
	// click handler to download product data in .json file.
	const handleClick = () => {
		var data = 'text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(product));
		var a = document.createElement('a');
		a.href = 'data:' + data;
		a.download = `${get(product, productJsonProps.name, '')}.json`;
		a.innerHTML = 'download JSON';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	};
	return (
		<div>
			<Tooltip placement="top" arrow={true} title="Click to download Product information in a Json file">
				<IconButton color="primary" size="small" onClick={handleClick}>
					<GetAppIcon></GetAppIcon>
					<span>{downloadTxt}</span>
				</IconButton>
			</Tooltip>
		</div>
	);
};

export default ProductDownloadButton;
